// extracted by mini-css-extract-plugin
export var list = "sections-list-module--list--XTDN0";